import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatTableDataSource, MatDialogRef } from '@angular/material';
@Component({
  selector: 'app-details-mark',
  templateUrl: './details-mark.component.html',
  styleUrls: ['./details-mark.component.css']
})
export class DetailsMarkComponent implements OnInit {
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = [
    "date",
    "sessionTime",
    "status"
  ];
  constructor(
    private dialogRef: MatDialogRef<DetailsMarkComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {

    console.log(this.data);
    this.dataSource = this.data.Attendance;
  }

  getColor(state) {
    switch (state) {
      case 91:
        return "custom-chips primary";
      case 92:
        return "custom-chips accent";
        default:
          return "custom-chips default";
    }
  }
  onNoClick() {
    this.dialogRef.close();
  }
}
